import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import InventoryService from '../../../../services/InventoryService';
import { translate, showMessageToastCustom } from '../../../../utils/util';
import { Input, BackButton, } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import ButtonUI from '../../../../components/UI/ButtonUI';

const InventoryQrCodeRange = (props) => {
    const [model, setModel] = useState({
        inicialQrCode: undefined,
        finalQrCode: undefined
    });

    useEffect(() => {
        props.getRangeQrCode(props.inventory.id,
            (response) => {
                setModel({
                    inicialQrCode: response.inicialQrCode,
                    finalQrCode: response.finalQrCode
                })
            })
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    const submit = () => {
        if (validateInputsRequired("formQrCodeRange")) {
            props.updateQrCodeRange({
                ...model,
                inventoryId: props.inventory.id
            }, () => {
                props.history.go(-1)
                showMessageToastCustom(translate('general.info'), translate('range-success', 'inventory'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            });
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div id="formQrCodeRange" className="card-content" style={{ padding: '15px', paddingBlockEnd: '1px' }}>
                        <text>{props.inventory.code} - {props.inventory.name}</text>
                        <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                            <Input
                                required
                                id="inicialQrCode"
                                name="inicialQrCode"
                                type="number"
                                label="Range Inicial"
                                onChange={onChange}
                                defaultValue={model.inicialQrCode || ''}
                            />
                        </div>
                        <div className="input-field no-padding col s12" style={{ marginTop: '20px' }}>
                            <Input
                                required
                                id="finalQrCode"
                                name="finalQrCode"
                                type="number"
                                label="Range Final"
                                onChange={onChange}
                                defaultValue={model.finalQrCode || ''}
                            />
                        </div>
                        <div className="row" style={{ margin: '10px 0 15px 0' }}>
                            <div className="col s12">
                                <ButtonUI
                                    onClick={() => submit()}
                                    full="true" text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        inventory: state.inventoryReducer.inventory
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateQrCodeRange: (data, callback) => {
            dispatch(InventoryService.updateQrCodeRange(data, callback));
        },
        getRangeQrCode: (data, callback) => {
            dispatch(InventoryService.getRangeQrCode(data, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InventoryQrCodeRange));